import React from 'react';

import { NavLink } from 'react-router-dom';
import MyPage from "../../../src/MyPage";
import SubTabsWarehouses from "../../../src/SubTabsWarehouses";

import '../../App.css';
import '../../styles.css';
  function Warehouses() {
    return (
      <div className="scrollable-container">
        <MyPage />
        <SubTabsWarehouses />
      </div>
    );
  }
export default Warehouses;